import { NavigationApi } from '../../../../api/NavigationApi';
import { ottActionFilter } from '../../../../api/models/ActionFilter';
import { SearchApi } from '../../../../api/SearchApi';
import { AdultType, ExtraDataType } from '../../../../api/models/Shared.types';
import { SearchRowDataSource } from '../../../../Business/cms/search/SearchRowDataSource';
import { Log } from '@lightningjs/sdk';

export class SearchPageDataSource {
  /**
   * @param {Backend} backend
   * @param menuItem
   */
  constructor(backend, menuItem) {
    this.backend = backend;
    this.menuItem = menuItem;
    /**
     * @type {ChannelModel[]}
     */
    this.channels = [];
  }

  init() {
    const customParam = {
      entitlementId: this.backend.sessionInfo.device.entitlementId,
      actionFilter: ottActionFilter,
      adult: false,
    };
    return NavigationApi.customPage(this.backend, this.menuItem.pageId, customParam)
      .then(page => {
        this.page = page;
        Log.info(page);
      })
      .catch(error => {
        Log.error(error);
      });
  }

  search(term) {
    const extraData = this.page.searchPage.properties.includes('HIDE_MINI_DETAIL')
      ? ExtraDataType.NONE
      : ExtraDataType.MINI;
    const searchProm = SearchApi.search(
      this.backend,
      term,
      this.page.searchPage.rows.map(row => row.type),
      AdultType.False,
      this.backend.deviceProfile.profile.catalog,
      true,
      0,
      extraData
    );
    const channelProm = this.backend.cachedChannelApi.channels(this.backend);
    return Promise.all([searchProm, channelProm])
      .then(([searchRes, channels]) => {
        this.channels = channels;
        return { completions: searchRes.completions, rows: this.convert(searchRes) };
      })
      .catch(err => {
        Log.error(err);
        return { completions: [], rows: [] };
      });
  }

  /**
   * @param {ISearchResponseV3} data
   */
  convert(data) {
    let rows = data.results;
    const isGrid = rows.length === 1;

    return rows.map(row => new SearchRowDataSource(this.backend, this.page, row, isGrid, this.channels));
  }

  logPageView() {
    this.backend.logService.trackPageView(this.menuItem.pageId, this.menuItem.title);
  }
}
